export default "__VITE_ASSET__DMeZWlwe__"